import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useBranding } from "../lib/useBranding";
import { Spinner, ErrorNote } from "../components/ui";

export function Login() {
  const { session, signIn } = useAuth();
  const { logo, title, subtitle } = useBranding();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (session) return <Navigate to="/" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error } = await signIn(email.trim(), password);
    setBusy(false);
    if (error) setError(error);
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-plane p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          {logo ? (
            <img src={logo} alt={title} className="h-9 w-9 rounded-lg object-contain" />
          ) : (
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-base font-bold text-white">
              L
            </div>
          )}
          <div>
            <div className="text-lg font-semibold text-ink">{title}</div>
            <div className="text-xs uppercase tracking-wide text-muted">{subtitle}</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="card space-y-4 p-6">
          <div>
            <label className="label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <ErrorNote message={error} />}
          <button type="submit" className="btn-primary w-full" disabled={busy}>
            {busy && <Spinner className="h-4 w-4" />}
            Sign in
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-muted">
          Access is managed by Load Studios. Contact your account manager for a login.
        </p>
      </div>
    </div>
  );
}
